import { put, select } from 'redux-saga/effects';
import { adminSetChannelsAction, adminSetPoliciesAction } from 'pages/administration.page/actions';
import { fetchPoliciesApi } from 'common/api/website';
import { fetchChannelsApi } from 'common/api';
import { getRootChannel, getSubChannels } from 'utils/common';
import { tokenizePolicies } from 'pages/administration.page/utils';
import { channelsSelector } from 'common/selectors/channels';
import { channelsSuccessAction } from 'common/actions/channels';

export function* fetchPoliciesEffect({ payload }) {
  try {
    const policies = yield fetchPoliciesApi(payload.websiteId);
    let channels = yield select(channelsSelector);
    if (channels.length === 0) {
      channels = yield fetchChannelsApi();
      yield put(channelsSuccessAction(channels));
    }
    const rootChannels = getSubChannels(channels, getRootChannel(channels));

    yield put(adminSetChannelsAction(rootChannels));
    yield put(adminSetPoliciesAction(tokenizePolicies(policies)));
  } catch (error) {}
}
